import moment from "moment";
import i18n from "@/services/i18n";

export default {
    filters: {
        formatDateFrom(date) {
            if (!date) return "-";
            //moment.locale("ru");
            moment.locale(i18n.locale);
            const now = new Date().toISOString().substr(0, 19);
            return moment(date).from(now);
        }
    }
}